export default __webpack_public_path__ + "static/media/toledo_4.ceb967b1.png";